import React from 'react';
import {connect} from 'react-redux';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
import _ from 'lodash';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import AlertBox from './AlertBox';
import UploadPanel from '../upload/UploadPanel';

import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import AppConfig from "../../utils/appConfig";
const log = new Logger('UPLOAD_MODAL', LOG_LEVELS.DEBUG);
const MODAL_CLASSNAMES =  {
    modal: 'modal-max-width-75'
};

class UploadModal extends React.Component {

    constructor(props) {
        super(props);
        this.onUploadRequest = this.onUploadRequest.bind(this);
        this.state = {
            showFilesMissingAlert: false
        };
    }

    onUploadRequest(filesToBeSent) {
        log.debug('onUploadRequest(): ', filesToBeSent);
        if(filesToBeSent.length <= 0){
          this.setState({
            showFilesMissingAlert: true
          });
          return;
        }
        this.props.onSubmit(filesToBeSent);
    }
    
    render() {
        log.debug('render(): ');
        let {
            maxNumberOfFiles=1,
            maxFileSize=Infinity,
            fileTypes,
            open=false,
            onClose,
            titleKey
        } = this.props;

        fileTypes = _.isArray(fileTypes) ? fileTypes : [fileTypes];
        log.debug('render(): fileTypes: ', fileTypes);
        return(
            <div>
                <AlertBox show={this.state.showFilesMissingAlert} messageKey="uploadModal_MissingFilesAlert" onClose={ () => {
                    this.setState({
                        showFilesMissingAlert: false
                    })
                }} />
                <Modal
                    classNames={MODAL_CLASSNAMES}
                    open={open}
                    onClose={onClose}
                    closeOnEsc={true}
                    blockScroll={true}
                    closeOnOverlayClick={false}
                    center
                >
                    {
                        titleKey && !_.isEmpty(titleKey) 
                        ? (
                            <h2 className="mb15"><LanguageStringResolver string={titleKey}/></h2>
                        ) : (
                            <h2 className="mb15"></h2>
                        )
                    }
                    <UploadPanel
                        uploadLimit={maxNumberOfFiles}
                        acceptTypes={fileTypes}
                        onUploadRequest={this.onUploadRequest}
                        maxSizeInKB={maxFileSize * AppConfig.UploadConfig.bytesPerKB}
                    /> 
                    <s-box>
                        <h2><LanguageStringResolver string='uploadInformation'/></h2>
                        <p>                            
                            <LanguageStringResolver string='acceptedFormats'/>
                            <br /> 
                            {fileTypes.map((fileType, index) => {
                                return (
                                    <span key={index} className="semi-bold">
                                        <LanguageStringResolver string={fileType}/>
                                    </span>
                                )
                            })}
                        </p>
                        <p>
                            <LanguageStringResolver string='uploadModal_maxFileSize'/>:
                            <br/>
                            {
                                Number.isFinite(maxFileSize) ? (
                                    <span>
                                        {
                                        `${maxFileSize} MB`
                                        }
                                    </span>
                                ) : (
                                    <LanguageStringResolver string='uploadModal_noLimit'/>
                                )
                            }
                            
                        </p>
                        <p className="mb5"><LanguageStringResolver string='rightToUse'/></p>
                    </s-box>
                </Modal>
            </div>
        );
    }
}


UploadModal.defaultProps = {
    titleKey: '',
    onClose: () => {},
    attachmentUpload: {},
    onSubmit: () => {},
    maxNumberOfFiles: 1,
    maxFileSize: Infinity,
    fileTypes: '.*'
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(UploadModal);
